export default "__VITE_ASSET__D5bjD2cq__"